export const config = {
  title: "Zavala Bros Car Wash NY",
  meta: {
    description:
      "Zavala Bros Car Wash offers professional auto detailing and car wash services in Selden, NY. Experience a spotless shine and reliable service.",
    keywords: [
      "Car Wash Selden NY",
      "Auto Detailing Selden",
      "Zavala Bros Car Wash",
      "Hand Car Wash NY",
      "Car Cleaning Services NY",
    ],
    author: "Zavala Bros Car Wash NY",
    canonicalUrl: "https://carwash-ny.com/",
  },
  sections: {
    header: {
      businessName: "Zavala Bros Car Wash NY",
    },
    sectionB: {
      heroTitle: "Top-Quality Car Wash in Selden, NY",
      heroSubtitle: "Keeping Your Car Spotless & Shiny",
      learnAboutText: "Our Services",
      phoneNumber: "6318800601",
      phoneLabel: "(631) 880-0601",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1417974598/photo/a-man-washes-his-car-at-a-self-service-car-wash-using-a-hose-with-pressurized-water.jpg?s=612x612&w=0&k=20&c=I1Ubvo07qMyhsZdPHD4fBoR6JZDpzEmLANAT474Cxjk=",
      cardData: [
        {
          title: "Exterior Wash",
          description:
            "High-pressure rinse, foam bath, and hand-dry finish to keep your car gleaming.",
        },
        {
          title: "Interior Detailing",
          description:
            "Thorough interior vacuum, wipe down, and window cleaning for a fresh cabin feel.",
        },
        {
          title: "Premium Packages",
          description:
            "Enjoy full-service combos tailored for maximum value and performance.",
        },
      ],
      description:
        "Zavala Bros Car Wash NY delivers top-tier cleaning and detailing services. From quick washes to full detailing, experience unmatched quality and customer care in Selden.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Expert car wash and detailing solutions to keep your vehicle in peak condition.",
      cards: [
        {
          title: "Exterior Car Wash",
          description:
            "Comprehensive exterior cleaning with foam, wax, and spot-free rinse.",
          imageSrc:
            "https://media.istockphoto.com/id/174942860/photo/tire-wash.jpg?s=612x612&w=0&k=20&c=IHqUkH8UZl1vyS02BAU5zbJ2xvE-_NMFwSXOgfr2jdI=",
          imageAlt: "Exterior Car Wash",
        },
        {
          title: "Detailing Services",
          description:
            "Complete detailing for a showroom-quality clean and polish.",
          imageSrc:
            "https://media.istockphoto.com/id/2210225131/photo/car-detailing-nano-coating-on-a-car.jpg?s=612x612&w=0&k=20&c=aYCVw3ONBTsbX5jnfPVanAoHjlcR5nXu2X5qyB6TBkA=",
          imageAlt: "Detailing Services",
        },
        {
          title: "Interior Vacuuming",
          description:
            "Thorough vacuuming and cleaning of seats, carpets, and mats.",
          imageSrc:
            "https://media.istockphoto.com/id/1339665859/photo/car-service-and-car-wash.jpg?s=612x612&w=0&k=20&c=gA3s2bkxZf3bp17RMLvmHX4Xt6aq7aG8zUo1a1SvY_M=",
          imageAlt: "Interior Vacuuming",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Tire Shine",
        "Engine Cleaning",
        "Undercarriage Wash",
        "Paint Protection",
        "Clay Bar Treatment",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://carwash-ny.com/wp-content/uploads/2025/05/Car-Exterior-Detailing.webp", // Replace with actual image if different
        alt: "Zavala Bros Car Wash Team",
      },
      aboutText: [
        "Zavala Bros Car Wash NY is a family-owned business built on trust, quality, and customer satisfaction.",
        "Located in Selden, NY, we’ve proudly served the community with high-end car cleaning services and professional care.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Zavala Bros Car Wash NY Logo",
      businessName: "Zavala Bros Car Wash NY",
      contact: {
        phone: "6318800601",
        phoneLabel: "(631) 880-0601",
        email: "zavalabro@gmail.com",
        website: "https://carwash-ny.com/",
        address: "22 Jane St, Selden, NY 11784",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "22 Jane St, Selden, NY 11784",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=22+Jane+St,+Selden,+NY+11784&output=embed",
    },
  },
};

export default config;
